import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createContactSalesRepresentative } from "../../../../app/homeSlice";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";

const PRODUCT_TYPE = {
  FAMILY: "family",
  MATERIAL: "material",
};

export const useRequestMoreInfo = ({ selectedProductId, selectedMaterialId }) => {
  const dispatch = useDispatch();

  const moreInfoLoading = useLoading(LOADING_KEYS.EMAIL_CONTACT_SALE_REP);

  const [reqSuccessMessage, setReqSuccessMessage] = useState(null);

  useEffect(() => {
    if (!reqSuccessMessage) return undefined;
    const timer = setTimeout(() => setReqSuccessMessage(null), 10000);
    return () => clearTimeout(timer);
  }, [reqSuccessMessage]);

  const handleRequestMoreInfo = async (type, isFormularyProduct) => {
    const payload = {
      productFamilyId: type === PRODUCT_TYPE.FAMILY ? selectedProductId : "0",
      appVersion: "4.0.61",
      searchText: "",
      materailId: type === PRODUCT_TYPE.MATERIAL ? selectedMaterialId : "0",
      isFormularyProduct: isFormularyProduct,
      pageName: "ProductDetail",
    };
    const response = await dispatch(createContactSalesRepresentative(payload));
    setReqSuccessMessage(response);
  };
  return {
    moreInfoLoading,
    reqSuccessMessage,
    setReqSuccessMessage,
    handleRequestMoreInfo,
  };
};
